import { API_ENDPOINTS } from '../config/apiConfig';
import apiClient from './apiClient';
import { RtuStatusHistoryQuery, RtuStatusHistoryResponse } from '../types/RtuStatusHistory';

const stripEmpty = (query: Record<string, string | undefined>) =>
  Object.fromEntries(
    Object.entries(query).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

export const rtuStatusHistoryService = {
  async fetch(query: RtuStatusHistoryQuery): Promise<RtuStatusHistoryResponse> {
    const response = await apiClient.get<RtuStatusHistoryResponse>(API_ENDPOINTS.RTU.STATUS_HISTORY, {
      params: stripEmpty({
        range: query.range,
        rtuId: query.rtuId !== undefined ? String(query.rtuId) : undefined,
      }),
    });

    return response.data;
  },
};

export default rtuStatusHistoryService;
